import React from 'react';
import { FilesInUseContent } from './FilesInUseContent';
export const getKeepFilesModalOptions = props => {
  const {
    usedFilesCount,
    deleteFiles,
    keepFiles,
    closeModal,
    onCloseWithCloseButtonClick,
    onAfterClose,
    formatMessage
  } = props;
  return {
    customLayout: true,
    width: '660px',
    height: '480px',
    showHeaderDivider: true,
    showFooterDivider: true,
    noBodyPadding: true,
    title: formatMessage({
      id: 'files-manager.delete-permanently-modal-confirmation.title'
    }, {
      itemsCount: usedFilesCount
    }),
    confirmText: formatMessage({
      id: 'files-manager.delete-permanently-modal-confirmation.primary-cta'
    }),
    cancelText: formatMessage({
      id: 'files-manager.delete-permanently-modal-confirmation.secondary-cta'
    }),
    content: /*#__PURE__*/React.createElement(FilesInUseContent, props),
    primaryButtonProps: {
      skin: 'standard'
    },
    secondaryButtonProps: {
      skin: 'destructive'
    },
    onOk: keepFiles,
    onCancel: deleteFiles,
    onClose: closeModal,
    onAfterClose,
    onCloseWithCloseButtonClick
  };
};
//# sourceMappingURL=getKeepFilesInUse.js.map